/*
 * Copyright (c) 2016. CodeGen Ltd. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by dilupa on 7/20/2021.
 */

export let PermissionKeys = {
  ACCESS_ALL_BOOKINGS: 'SURF-ACCESS-ALL-BOOKINGS'
};


